/*
 * custom.js (mundizio) — v8 (2026-09-15): Meta-Klick-ID (fbclid) wie die gclid.
 *   Landung mit fbclid -> localStorage reffbc = fb.1.<ms>.<fbclid> (Meta-Format), Cart-Attribut reffbc, und nach
 *   Marketing-Zustimmung der Cookie _fbc (90 Tage), damit das Pixel die Klick-ID auch bekommt, wenn der Kunde erst
 *   nach dem Weiterklicken zustimmt (Befund 15.09.: sonst fbc null). Ablauf 21 Tage wie gclid.
 * v7 (2026-09-14): Attribut-Write ueber den gemeinsamen Schreiber
 *   window.mdzoCartWrite (mdzo-cart-writer.js): ein serialisierter, gesammelter update.js statt je Skript
 *   ein eigener paralleler Write. Fallback ohne Schreiber: direkter fetch wie bisher.
 * v6 (2026-09-14): Attribute reisen mit dem Kassen-Formular.
 *   1. submit-Capture auf Formularen mit action /cart (Kasse-Button im Drawer): die Felder
 *      attributes[refcons] (+ ref/refgid/refgbid/refwbid, wenn vorhanden) werden im Absende-Moment
 *      gesetzt — synchron im selben Request wie der Checkout-Start. Beleg 07.-14.09.: ~4 % der
 *      Web-Bestellungen ohne refcons/_kx, 8 davon mit nur EINEM Attribut = asynchroner Write kam
 *      nach dem Kasse-Klick. Nie leere Felder (ein leeres Feld loescht das Attribut). Wallet-Buttons
 *      laufen nicht ueber das Formular -> die asynchronen Writes bleiben als Absicherung.
 *   2. Marker an den Warenkorb gebunden: markSynced merkt das Shopify-Cookie 'cart'; ein anderer
 *      Warenkorb (nach Bestellung, anderes Geraet) macht den Marker ungueltig. Der Token wurde bisher
 *      gespeichert, aber nie verglichen.
 * v5 (2026-09-05): Cart aus dem Theme-Event, Lauf im Leerlauf (Vermerk im Rumpf).
 * v4 (2026-09-02): refcons an JEDER Web-Bestellung.
 * Bisher wurde das Consent-Attribut nur mitgeschrieben, wenn ein Ads-
 * Referrer (ref/refgid/refgbid/refwbid) vorlag; Shopify selbst speichert
 * den Tracking-Consent nirgends an der Bestellung. Ab v4 traegt jeder
 * Warenkorb "refcons" (grant/deny) — der Wert wird bei jedem Warenkorb-
 * Ereignis neu gelesen und nur bei Aenderung geschrieben (Consent kann
 * sich in der Sitzung aendern). Uebrige Logik unveraendert (v3-Stand ohne
 * bfcache-/visitorConsentCollected-Listener, Nutzer-Entscheidung 29.08.).
 */
(function () {
  var PENDING_KEY = 'jgd-ad-products-pending';
  var MARKER_KEY = 'jgd-ad-tracking-synced';
  var CAPTURED_AT_KEY = 'jgd-ad-captured-at';
  var MAX_ENTRIES = 15;
  var REF_TTL_MS = 21 * 24 * 60 * 60 * 1000;
  var MARKER_TTL_MS = 60 * 60 * 1000;
  var flushing = false;
  var queued = false;
  var queuedForce = false;

  var REF_ATTRIBUTES = {
    refid: 'ref',
    refgid: 'refgid',
    refgbid: 'refgbid',
    refwbid: 'refwbid',
    reffbc: 'reffbc',
    refcons: 'refConsent'
  };
  var REF_VALUE_KEYS = ['ref', 'refgid', 'refgbid', 'refwbid', 'reffbc'];

  function lsGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function lsSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  function lsRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  function readPending() {
    try { return JSON.parse(lsGet(PENDING_KEY)) || []; } catch (e) { return []; }
  }

  function writePending(list) {
    if (list.length) {
      lsSet(PENDING_KEY, JSON.stringify(list));
    } else {
      lsRemove(PENDING_KEY);
    }
  }

  function consentValue() {
    var v = lsGet(REF_ATTRIBUTES.refcons);
    if (v) return v;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent();
        if (c && c.marketing === 'yes') return 'grant';
      }
    } catch (e) {}
    return 'deny';
  }

  // v4: refcons immer, die Referrer-Werte nur, wenn vorhanden.
  function refValues() {
    var values = {};
    Object.keys(REF_ATTRIBUTES).forEach(function (attrKey) {
      if (attrKey === 'refcons') return;
      var value = lsGet(REF_ATTRIBUTES[attrKey]);
      if (value) values[attrKey] = value;
    });
    values.refcons = consentValue();
    return values;
  }

  function hasRefData() {
    return REF_VALUE_KEYS.some(function (key) { return !!lsGet(key); });
  }

  function hasData() {
    return readPending().length > 0 || hasRefData();
  }

  function expireStale() {
    if (!hasData()) return;
    var ts = parseInt(lsGet(CAPTURED_AT_KEY), 10);
    if (!ts) {
      lsSet(CAPTURED_AT_KEY, String(Date.now()));
      return;
    }
    if (Date.now() - ts > REF_TTL_MS) {
      REF_VALUE_KEYS.forEach(function (key) { lsRemove(key); });
      writePending([]);
      lsRemove(CAPTURED_AT_KEY);
      lsRemove(MARKER_KEY);
    }
  }

  function currentSig() {
    return JSON.stringify([refValues(), readPending()]);
  }

  // v8: Meta-Klick-ID. Format fb.<version>.<subdomainIndex>.<creationTime ms>.<fbclid>; die fbclid ist alles nach
  // dem dritten Punkt (sie selbst kann Punkte enthalten).
  function fbcTeile(wert) {
    var t = String(wert || '').split('.');
    if (t.length < 4 || t[0] !== 'fb') return null;
    return { zeit: parseInt(t[2], 10) || 0, fbclid: t.slice(3).join('.') };
  }
  function cookieLesen(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    return parts.length === 2 ? decodeURIComponent(parts.pop().split(';').shift()) : '';
  }
  function captureFbclid(fbclid) {
    var alt = fbcTeile(lsGet('reffbc'));
    if (alt && alt.fbclid === fbclid) return;
    var cookie = fbcTeile(cookieLesen('_fbc'));
    var wert = cookie && cookie.fbclid === fbclid ? cookieLesen('_fbc') : 'fb.1.' + Date.now() + '.' + fbclid;
    lsSet('reffbc', wert);
    lsSet(CAPTURED_AT_KEY, String(Date.now()));
  }
  function marketingErlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var c = cp && typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return !!(c && c.marketing === 'yes');
    } catch (e) { return false; }
  }
  // Cookie _fbc nur nach Marketing-Zustimmung; nie einen neueren vorhandenen Wert ueberschreiben.
  function fbcCookieSetzen() {
    var wert = lsGet('reffbc'); var neu = fbcTeile(wert);
    if (!neu || !marketingErlaubt()) return;
    var vorhanden = fbcTeile(cookieLesen('_fbc'));
    if (vorhanden && (vorhanden.fbclid === neu.fbclid || vorhanden.zeit >= neu.zeit)) return;
    var host = location.hostname.split('.'); var domain = host.length > 2 ? host.slice(-2).join('.') : location.hostname;
    var ablauf = new Date(Date.now() + 90 * 864e5).toUTCString();
    try { document.cookie = '_fbc=' + wert + '; expires=' + ablauf + '; path=/; domain=.' + domain + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (e) {}
  }

  function captureAdClick(params) {
    var gclid = params.get('gclid');
    var gbraid = params.get('gbraid');
    var wbraid = params.get('wbraid');
    lsSet('ref', location.href);
    if (gclid) lsSet('refgid', gclid);
    if (gbraid) lsSet('refgbid', gbraid);
    if (wbraid) lsSet('refwbid', wbraid);
    lsSet(CAPTURED_AT_KEY, String(Date.now()));
  }

  function adEntry(params) {
    var pid = null;
    var vid = params.get('variant');
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (m && m.product && m.product.id) pid = String(m.product.id);
      if (!vid && m) {
        if (m.selectedVariantId) {
          vid = String(m.selectedVariantId);
        } else if (m.product && m.product.variants && m.product.variants.length) {
          vid = String(m.product.variants[0].id);
        }
      }
    } catch (e) {}
    if (pid) return pid + (vid ? ':' + vid : '');
    var match = location.pathname.match(/\/products\/([^/]+)/);
    return match ? 'h:' + match[1] : null;
  }

  // v7: gemeinsamer Schreiber, wenn vorhanden (sammelt/serialisiert); sonst direkt
  function cartSchreiben(body) {
    if (typeof window.mdzoCartWrite === 'function') return window.mdzoCartWrite(body).then(function (cart) { return !!cart; });
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.ok; });
  }

  function readMarker() {
    try { return JSON.parse(lsGet(MARKER_KEY)); } catch (e) { return null; }
  }

  // v6: Shopify-Cookie 'cart' = aktueller Warenkorb (JS-lesbar, wie in md-versand.js)
  function cartCookie() {
    var parts = ('; ' + document.cookie).split('; cart=');
    return parts.length === 2 ? parts.pop().split(';').shift() : '';
  }

  // v6: versteckte Felder attributes[...] im Absende-Moment des Kassen-Formulars
  // (action /cart, nicht /cart/add|change|update). Nur bekannte Werte, nie leer.
  function feldSetzen(form, name, wert) {
    var inp = form.querySelector('input[name="' + name + '"]');
    if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = name; form.appendChild(inp); }
    inp.value = wert;
  }
  function kassenFormular(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var a = form.getAttribute('action') || '';
    return /\/cart\/?(\?|$)/.test(a) && !/\/cart\/(add|change|update)/.test(a);
  }
  document.addEventListener('submit', function (ev) {
    try {
      if (!kassenFormular(ev.target)) return;
      var werte = refValues();
      Object.keys(werte).forEach(function (k) { if (werte[k]) feldSetzen(ev.target, 'attributes[' + k + ']', werte[k]); });
    } catch (e) {}
  }, true);

  // v4: laeuft auch ohne Referrer-Daten (refcons ist immer zu schreiben);
  // die Marker-Logik verhindert wiederholte Cart-Reads bei unveraendertem
  // Zustand, der Payload-Vergleich verhindert unnoetige Cart-Writes.
  // v5 (05.09.2026): cart optional aus dem Theme-Event (detail.cart) -- spart den GET /cart.js
  // direkt nach dem Add, waehrend der Drawer rendert.
  function flush(force, cart) {
    if (flushing) {
      queued = true;
      queuedForce = queuedForce || force;
      return;
    }
    if (!force) {
      var marker = readMarker();
      // v6: nur bei demselben Warenkorb ueberspringen (Cookie 'cart' wie beim Sync)
      if (marker && marker.sig === currentSig() && marker.cc === cartCookie() &&
          marker.ts && Date.now() - marker.ts < MARKER_TTL_MS) return;
    }
    flushing = true;
    (cart && typeof cart.item_count === 'number'
      ? Promise.resolve(cart)
      : fetch('/cart.js').then(function (r) { return r.json(); }))
      .then(function (cart) {
        var attrs = cart.attributes || {};
        var ourKeys = Object.keys(REF_ATTRIBUTES).concat('ad_products');
        var cartHasOurs = ourKeys.some(function (k) { return attrs[k]; });
        if (!cart.item_count && !cartHasOurs) return;

        var payload = {};
        var desired = refValues();
        Object.keys(desired).forEach(function (key) {
          if (String(attrs[key] || '') !== desired[key]) payload[key] = desired[key];
        });

        var stored = String(attrs.ad_products || '').split(',').filter(Boolean);
        var pendingAtRead = readPending();
        var list = stored.slice();
        pendingAtRead.forEach(function (entry) {
          if (list.indexOf(entry) === -1) list.push(entry);
        });
        if (list.length !== stored.length) {
          payload.ad_products = list.slice(-MAX_ENTRIES).join(',');
        }

        var syncedSig = JSON.stringify([desired, []]);

        function markSynced() {
          var remaining = readPending().filter(function (entry) {
            return pendingAtRead.indexOf(entry) === -1;
          });
          writePending(remaining);
          if (remaining.length) {
            lsRemove(MARKER_KEY);
            queued = true;
          } else {
            lsSet(MARKER_KEY, JSON.stringify({
              sig: syncedSig,
              token: cart.token,
              cc: cartCookie(),
              ts: Date.now()
            }));
          }
        }

        if (!Object.keys(payload).length) {
          markSynced();
          return;
        }
        return cartSchreiben({ attributes: payload }).then(function (ok) {
          if (ok) markSynced();
        });
      })
      .catch(function () {})
      .then(function () {
        flushing = false;
        if (queued) {
          queued = false;
          var f = queuedForce;
          queuedForce = false;
          flush(f);
        }
      });
  }

  function run() {
    expireStale();
    var params = new URLSearchParams(location.search);
    var isAd = params.has('gclid') || params.has('gbraid') || params.has('wbraid') ||
      (params.get('utm_source') === 'google' && params.get('utm_medium') === 'cpc');
    if (isAd) {
      captureAdClick(params);
      var entry = adEntry(params);
      if (entry) {
        var pending = readPending();
        if (pending.indexOf(entry) === -1) {
          pending.push(entry);
          writePending(pending.slice(-MAX_ENTRIES));
        }
      }
    }
    // v8: Meta-Klick-ID unabhaengig von Google-Parametern erfassen; Cookie sofort (Zustimmung schon da) oder bei der
    // Entscheidung. Danach flush wie bisher (reffbc ist Teil von REF_ATTRIBUTES).
    var fbclid = params.get('fbclid');
    if (fbclid) captureFbclid(fbclid);
    fbcCookieSetzen();
    document.addEventListener('visitorConsentCollected', function () { fbcCookieSetzen(); flush(true); });
    flush(false);
    // v5: Cart aus dem Event, Lauf erst im Leerlauf (nach dem Drawer-Rendern).
    ['on:cart:add', 'on:line-item:change', 'cart:update'].forEach(function (name) {
      document.addEventListener(name, function (ev) {
        var cart = ev && ev.detail && ev.detail.cart;
        var lauf = function () { flush(true, cart); };
        if (window.requestIdleCallback) { window.requestIdleCallback(lauf, { timeout: 2000 }); }
        else { setTimeout(lauf, 800); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();